import React from "react";

import { Container, Row, Col, Button } from "reactstrap";
import Countries from "./Countries";
import S2 from "./svgs/s2";
import S3 from "./svgs/s3";
import S8 from "./svgs/s8";
import S1 from "./svgs/s1";
import ScrollAnimation from "react-animate-on-scroll";
import Slider from "react-slick";
import { size } from "./common";

function Speaker({ speakers }) {
  const content = [
    {
      title: "The Next Phase of Saudi Arabia’s Fintech Revolution",
      description:
        "Navigating regulatory landscapes, fostering collaboration between traditional banks and fintech firms, and driving seamless digital adoption. ",
      image: <S2 />,
    },
    {
      title: "Open Banking and Vision 2030",
      description:
        "With Saudi Arabia's regulatory push towards open banking aligning with Vision 2030’s digital transformation and financial sector development goals. This theme explores how Open Banking will enhance competition, foster innovation, and drive financial inclusion in the Kingdom.",
      image: <S3 />,
    },
    {
      title: "The Evolution of Digital-First Banking",
      description:
        "Customer expectations are evolving, and digital-first banking is no longer optional—it’s essential. From AI-powered chatbots and hyper-personalized financial products to next-generation neobanks and super apps, this session will highlight how financial institutions are redefining customer engagement through seamless, AI-driven digital banking experiences.",
      image: <S1 />,
    },
  ];
  const content1 = [
    {
      title: "Insights",
      description:
        "Finnovex Saudi Arabia 2025 is where bold financial leaders meet the future. This summit delivers actionable insights on fintech innovations and sustainable banking practices, empowering institutions to lead in the face of rapid digital transformation. Through keynotes, case studies, and data-driven presentations, attendees will gain strategies for future-proofing operations, enhancing customer experiences, and staying competitive in an evolving market.",
    },
    {
      title: "Networking",
      description:
        "Finnovex creates an environment for meaningful connections. Curated networking sessions, private meetings, and strategic partnerships empower financial institutions, fintech innovators, and government leaders to collaborate, explore investment opportunities, and expand their networks in exclusive networking breaks.",
    },
    {
      title: "Spotlight",
      description:
        "Maximize your brand visibility at Finnovex Saudi Arabia 2025. Leverage Finnovex’s diverse media channels to engage a wide audience. Connect with decision-makers through personalized networking, sponsor demos, and impactful presentations, all designed to elevate your brand.",
    },
    {
      title: "Roundtables",
      description:
        "At the core of Finnovex Saudi Arabia 2025, elite roundtable sessions unite top CEOs, C-suite executives, and strategic leaders to address critical financial challenges. These intimate, closed-door discussions foster powerful alliances, offer transformative insights, and shape the future of business growth and economic innovation in Saudi Arabia.",
    },
  ];

  const settings = {
    dots: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 3000,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 1,
    className: "p-10",
    customPaging: function (i) {
      return <div className="dot"></div>;
    },
    dotsClass: "slick-dots slick-thumb",
  };
  return (
    <>
      <div
        style={{
          backgroundColor: "transparent",

          overflow: "hidden",
        }}
        className="section py-3"
      >
        <Container
          fluid
          style={{
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top right",

            backgroundSize: "80%",
          }}
        >
          <Container className="py-2">
            <Row>
              <Col lg={11}>
                {" "}
                <span className="text-white"></span>
                <h2 className="text-400 text-white">
                  <b>
                    Empowering the Fintech Ecosystem:
                    <br /> From Disruption to Collaboration
                  </b>
                </h2>
              </Col>
            </Row>
            <Row>
              <Col lg={6} md={6} sm={12} className="">
                <h5
                  className="text-600 text-white text-justify"
                  style={{
                    lineHeight: "30px",
                    color: "#010011",
                    textTransform: "none",
                  }}
                >
                  <br />
                  <br />
                  As the Kingdom of Saudi Arabia rapidly ascends as a global leader in digital
                  financeSaudi Arabia is making a bold push to redefine its financial ecosystem, as
                  seen in the launch of the Saudi Central Bank’s (SAMA) regulatory sandbox, the rise
                  of digital banking licenses, and increased venture capital investments fueling
                  fintech growth. Finnovex Saudi Arabia 2025 returns as the premier gathering of
                  visionaries, innovators, and decision-makers shaping the future of financial
                  services. Against the backdrop of Vision 2030’s ambitious financial sector
                  development goals, this year's summit will delve deep into the transformative
                  impact of fintech, artificial intelligence, cybersecurity, open banking, and
                  digital assets on the evolving financial landscape.
                  <br />
                  <br />
                  The 30th Edition of Finnovex Saudi Arabia 2025, scheduled for{" "}
                  <b>September 2-3 in Riyadh</b>, will bring together top-tier financial leaders,
                  innovators, and policymakers to explore how the Kingdom can harness disruption,
                  collaboration, and innovation to build a dynamic, inclusive, and sustainable
                  fintech ecosystem.
                  <br />
                  <br />
                </h5>
              </Col>
              <Col lg={6} className="mt-5">
                <div className="container-fluid row">
                  {content.map((s, index) => (
                    <Col className="text-center  p-2" lg={12}>
                      <ScrollAnimation
                        animateIn={"fadeInUp"}
                        animateOnce={true}
                        duration={1.5 + index / 8}
                      >
                        <div className="pt-4 px-2 stat-div" style={{ minHeight: 270 }}>
                          {s.image}

                          <h3
                            style={{
                              color: "#fff",
                              fontSize: "16px",
                            }}
                            className="text-700 mt-4"
                          >
                            {s.title}
                          </h3>
                          <h3
                            style={{
                              color: "#fff",
                              fontSize: "13px",
                            }}
                            className="text-600 mt-0"
                          >
                            {s.description}
                          </h3>
                        </div>
                      </ScrollAnimation>
                    </Col>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
          <Container>
            <Row>
              <Col lg={12}>
                <h3
                  style={{
                    color: "#fff",
                    fontSize: size ? "36px" : "20px",
                  }}
                  className="text-400 mt-0"
                >
                  Revolutionising Saudi Arabia's Financial Sector: A Global Outlook
                </h3>
              </Col>
            </Row>
            <Slider {...settings}>
              {content1.map((data, i) => (
                <div className="d-flex w-100 mb-5">
                  <Col lg={6} className="align-self-center">
                    <h3
                      style={{
                        color: "#fff",
                        fontSize: "36px",
                      }}
                      className="text-400 mt-0"
                    >
                      <i class="fa fa-quote-left text-primary" aria-hidden="true"></i>{" "}
                      <span className="pl-4 pr-4">{data.title}</span>
                      <i class="fa fa-quote-right text-primary" aria-hidden="true"></i>
                    </h3>
                    <h4 className="text-600 mt-0 text-white">{data.description}</h4>
                  </Col>
                  <Col lg={6}>
                    <img src={require(`assets/quotes/${i + 5}.jpg`)} width="100%" alt="main logo" />
                  </Col>
                </div>
              ))}
            </Slider>
          </Container>

          <Countries />
          <Container>
            <Row className="justify-content-center">
              <Col lg={4} className="text-center">
                <Button
                  href="/register"
                  className="btn my-2 text-center px-5"
                  color="primary"
                  size="lg"
                  outline
                >
                  Register Now
                </Button>
              </Col>
            </Row>
          </Container>
          <Container className="py-5">
            <Row className="justify-content-center">
              {images.map((id, i) => (
                <Col lg={4} xs={12} key={i}>
                  <img
                    alt="..."
                    className=" img-responsive my-3"
                    width="100%"
                    src={require(`assets/images/photos/${id}`)}
                  />
                </Col>
              ))}
            </Row>
          </Container>
        </Container>
      </div>
    </>
  );
}

export default Speaker;

const images = [
  "BO2A9941.jpg",
  "DSC_0119.jpg",
  "DSC_0154.jpg",
  "DSC_0168.jpg",
  "DSC_0178.jpg",
  "DSC_0195.jpg",
  "DSC_0332.jpg",
  "DSC_0511.jpg",
  "DSC_9715.jpg",
  "DSC_9854.jpg",
  "DSC_9885.jpg",
];
